module.exports = __webpack_public_path__ + "static/media/wizard-welcome.585ebe1b.svg";